import { AttributesMixin, define, type } from "@type-r/models";
import { restfulIO } from "./endpoint";
import { AssetChange } from "./assetChange";
import { Policy } from "./policy";
import { AssetType } from "./assetType";

export interface PolicyChange extends AttributesMixin<typeof PolicyChange> { }
@define
export class PolicyChange extends AssetChange {
    static endpoint = restfulIO('api/v1/ingest/policy/policies');

    static attributes = {
        ...AssetChange.attributes,
        isValidateOnly: Boolean,
        updateAsset: Policy,
        assetType: type(Number).value(AssetType.insurancePolicy)
    };

    getAssetType() {
        return AssetType.insurancePolicy;
    }

    getAssetName() {
        return 'Policy';
    }

    async validateAs(policy: Policy) {
        this.syncFrom(policy);

        const toValidate = new PolicyChange();
        toValidate.id = this.id;
        toValidate.syncFrom(policy);
        toValidate.isValidateOnly = true;
        await toValidate.save();
        this.errors = toValidate.errors;
    }
}
